import { AnswerListItemViewModel } from '@/features/bots/models/answers/answerListItemViewModel';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import { Module } from 'vuex';
import { AppState } from '../app';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from '@/store/answers/getters';

export interface AnswersState {
  answers: AnswerListItemViewModel[];
  currentAnswer: AnswerViewModel;
}

// initial state
export const answersState: AnswersState = {
  answers: [],
  currentAnswer: {
    id: '',
    title: '',
    intentId: '',
    status: FlowStatus.Draft,
    parentFlowIds: [],
    answerStates: [],
  },
};

export const answers: Module<AnswersState, AppState> = {
  namespaced: false,
  state: answersState,
  actions,
  mutations,
  getters,
};
